export const CrystalIcon = () => (<img src='/crystal100.png' className='crystal-icon' alt='Crystal' />)
export const JadeIcon = () => (<img src='/jade50.png' className='jade-icon' alt='Jade' />)
export const JewelIcon = () => (<img src='/jewel50.png' className='jewel-icon' alt='Jewel' />)

export const CommonIcon = () => (<img src='/rarity-common.png' className='rarity-icon' alt='Common' />)
export const UncommonIcon = () => (<img src='/rarity-uncommon.png' className='rarity-icon' alt='Uncommon' />)
export const RareIcon = () => (<img src='/rarity-rare.png' className='rarity-icon' alt='Rare' />)
export const LegendaryIcon = () => (<img src='/rarity-legendary.png' className='rarity-icon' alt='Legendary' />)
export const MythicIcon = () => (<img src='/rarity-mythic.png' className='rarity-icon' alt='Mythic' />)
